import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
export interface SistemaMantenimiento {
  id?: number;
  descripcion: string;
  estado: number;
}

@Injectable({
  providedIn: 'root'
})
export class SistemaMantenimientoService {
  private apiUrl =  `${environment.apiUrl}/api/sistema_mantenimientos`; 
  //private apiUrl = 'http://localhost:3000/api/sistema_mantenimientos'; // Ajusta si es necesario

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('token'); // O ajusta según dónde guardes el token
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
  }

  getAll(): Observable<SistemaMantenimiento[]> {
    return this.http.get<SistemaMantenimiento[]>(this.apiUrl, {
      headers: this.getHeaders()
    });
  }

  create(data: SistemaMantenimiento): Observable<SistemaMantenimiento> {
    return this.http.post<SistemaMantenimiento>(this.apiUrl, data, {
      headers: this.getHeaders()
    });
  }

  update(id: number, data: SistemaMantenimiento): Observable<SistemaMantenimiento> {
    return this.http.put<SistemaMantenimiento>(`${this.apiUrl}/${id}`, data, {
      headers: this.getHeaders()
    });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, {
      headers: this.getHeaders()
    });
  }
}